import AdminSectionsWrapper, {
  statCard,
  activityItem,
  adminSectionHeader,
  statsData,
  loader,
} from "../AdminUtils/Dashboard.admin";
import "./Dashboard.scss";
import { useAdminData } from "../DataContext/DataContext";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";


const DashboardSectionHeader = () =>
  adminSectionHeader(
    "Dashboard Overview",
    "Welcome back! Here's what's happening today."
  );

const AdminDashboardPage = () => {
  const navigate = useNavigate()
  const {  loading, messages,blogs } = useAdminData();

  const [activity, setActivity] = useState();

  const totalPosts = useMemo(() => blogs?.length, [blogs]);
  const UnreadMessages = useMemo(
    () => messages?.filter((msg) => !msg.read).length,
    [messages]
  );
  const pendingPosts = useMemo(
    () => blogs?.filter((blog) => blog?.pending)?.length,
    [blogs]
  );

  /*  fetch activities */

  const activities = useCallback(async () => {
    //fetching recent activities
    try{
      const api = process.env.REACT_APP_API_URL;
      const response = await fetch(`${api}/adm/recent-activities`,{
      credentials: "include",
    });
    if(response.status === 403){
      navigate("/admin/login")
    }
    const data = await response.json();
    if(response.ok){
      return data;  
    }}
    catch(err){
      console.error("Error fetching activities:", err);
      return [];
    }
    
  }, [navigate]);

  useEffect(() => {
    async function loadActivities() {
      const data = await activities();
      setActivity(data)
    }
    loadActivities();
  }, [activities]);

  /* if data is still fetching, show a spinner */

  if (loading) {
    return loader();
  }

  return (
    <div className="dashboard-content">
      {/* section title */}
      <DashboardSectionHeader />
      {/* stats mapping */}

      <div className="stats-grid">
        {statsData(totalPosts, pendingPosts, UnreadMessages)?.map((stat) => {
          return <div key={stat.id}>{statCard(stat)}</div>;
        })}
      </div>

      <div className="activity-section">
        <h2>Recent Activity</h2>
        <ul>
          {/* display activities */}
          {activity?.length > 0 && activity.map((a) => (
            <li key={a.id}>{activityItem(a)}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default function AdminDashboard() {
  return (
    <AdminSectionsWrapper>
      <AdminDashboardPage />
    </AdminSectionsWrapper>
  );
}
